import styled from 'styled-components';

import { Button } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const LastUsedDashboardLink = styled(Button)`
  display: inline-flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  padding: 4px 4px 4px 12px;
  background: ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};

  &:hover {
    background: ${ct({ Dark: Colors.DarkestMiddle, Light: Colors.DarkestMiddle })};
  }
`;
